import { isStorageAvailable } from '../../utils';

function addEvent(obj, evt, fn) {
  if (obj.addEventListener) {
    obj.addEventListener(evt, fn, false);
  } else if (obj.attachEvent) {
    obj.attachEvent(`on${evt}`, fn);
  }
}

const isTablet = window.innerWidth < 1024;
const getCookie = name => {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${`${name}`.replace(
        /([\.$?*|{}\(\)\[\]\\\/\+^])/g /* eslint-disable-line */,
        '\\$1',
      )}=([^;]*)` /* eslint-disable-line */,
    ),
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

class ExitPopup {
  constructor({
    targetPage = null,
    storage = 'localStorage',
    hideForExistsUsers = false,
    random = false,
    template = '',
    gaEventName = 'ExitPopup',
    gaEventLabel = null,
    bannerName = null,
    customClass = null,
    container = null,
    analytics = {
      type: 'gtag',
    },
  }) {
    this.targetPage = targetPage;
    this.gaEventLabel = gaEventLabel;
    this.containerPopup = document.createElement('div');
    this.storage = storage;
    this.hideForExistsUsers = hideForExistsUsers;
    this.random = random;
    this.template = template;
    this.content = document.createElement('div');
    this.overlay = document.createElement('div');
    this.closeBtn = document.createElement('span');
    this.gaEventName = gaEventName;
    this.container = container ? document.querySelector(container) : document.documentElement;
    this.bannerName = bannerName;
    this.customClass = customClass;
    this.analytics = { enable: true, ...analytics };
  }

  init() {
    if (isTablet) return;
    if (!this.bannerName && this.bannerName === '') throw new Error('bannerName is empty!');

    const lastAuthorizedAt = this.hideForExistsUsers
      ? (isStorageAvailable('localStorage') && localStorage.getItem('lastAuthorizedAt')) !== null
      : false;
    const acceptToShow = !this.checkInStorage() && !lastAuthorizedAt;

    if (acceptToShow) {
      this.containerPopup.classList.add('ExitPopup');
      this.containerPopup.classList.add(this.bannerName);
      if (this.customClass && this.customClass !== '')
        this.containerPopup.classList.add(this.customClass);
      this.containerPopup.classList.add('ExitPopup--hidden');
      this.content.classList.add('ExitPopup__content');
      this.overlay.classList.add('ExitPopup__overlay');

      if (this.random && Array.isArray(this.template)) {
        const randIndx = Math.floor(Math.random() * (this.template.length - 1 + 1));

        const template = document.createElement('div');
        template.innerHTML = this.template[randIndx].trim();
        const gaTemplateLabel = template.querySelector('[data-banner-btn]');

        if (gaTemplateLabel) {
          this.gaEventLabel = gaTemplateLabel.dataset.gaLabel || null;
        }

        this.content.innerHTML = this.template[randIndx];
      } else {
        this.content.innerHTML = Array.isArray(this.template) ? this.template[0] : this.template;
        this.gaEventLabel = this.gaEventLabel || null;
      }

      this.content.appendChild(this.closeBtn);
      this.closeBtn.classList.add('ExitPopup__close');
      this.closeBtn.setAttribute('data-exit-popup-close', '');
      this.containerPopup.appendChild(this.content);
      this.containerPopup.appendChild(this.overlay);
      this.container.appendChild(this.containerPopup);

      addEvent(document, 'mouseout', e => {
        const from = e.toElement === null || e.relatedTarget === null;
        if (from && e.clientY <= 0) {
          if (!this.containerPopup.classList.contains('ExitPopup--visible')) this.open();
        }
      });

      const closeNodes = this.container.querySelectorAll('[data-exit-popup-close]');
      if (closeNodes) {
        [...closeNodes].forEach(el =>
          el.addEventListener('click', () => {
            this.close();
            this.sendEvent('Close Popup', this.gaEventLabel, '1');
          }),
        );
      }

      this.overlay.addEventListener('click', () => {
        this.close();
        this.sendEvent('Close Popup', this.gaEventLabel, '1');
      });

      const buttonsNodes = this.container.querySelectorAll('[data-banner-btn]');
      if (buttonsNodes) {
        [...buttonsNodes].forEach(el =>
          el.addEventListener('click', () => {
            this.sendEvent('Click Popup', this.gaEventLabel, '1');

            if (this.targetPage) {
              this.sendEvent('target page', this.targetPage);
            }

            this.close();
          }),
        );
      }
    }
  }

  checkInStorage = () =>
    this.storage === 'cookie'
      ? getCookie(`${this.bannerName}_popup_closed`) !== undefined
      : localStorage.getItem(`${this.bannerName}_popup_closed`);

  sendEvent(eventAction, eventLabel, eventValue) {
    if (this.analytics.enable) {
      if (this.analytics.type === 'gtag') {
        // eslint-disable-next-line no-undef
        gtag('event', eventAction, {
          event_category: this.gaEventName,
          event_label: eventLabel || eventValue,
          value: eventValue,
        });
      } else if (this.analytics.type === 'ga') {
        // eslint-disable-next-line no-undef
        ga('send', 'event', {
          eventAction,
          eventCategory: this.gaEventName,
          eventLabel,
          eventValue,
        });
      }
    }
  }

  close() {
    this.containerPopup.classList.remove('ExitPopup--visible');
    this.containerPopup.classList.add('ExitPopup--hidden');
    if (this.storage === 'cookie') {
      document.cookie = `${this.bannerName}_popup_closed=${new Date().getTime()}`;
    } else {
      localStorage.setItem(`${this.bannerName}_popup_closed`, '1');
    }
  }

  open() {
    if (!this.checkInStorage()) {
      this.containerPopup.classList.remove('ExitPopup--hidden');
      this.containerPopup.classList.add('ExitPopup--visible');
      this.sendEvent('Show Popup', this.gaEventLabel, '1');
    }
  }
}

export default ExitPopup;
